import React from 'react';
import Icon, { IconName } from 'app/common/components/controls/icon';
import classes from 'classnames';
import styles from './MoonshotProgressIndicator.less';

interface ProgressStepProps {
  first?: boolean;
  last?: boolean;
  passed: boolean;
  active: boolean;
  step: number;
  children: React.ReactNode;
}

interface MoonshotProgressIndicatorProps {
  activeStep: number;
}

const ProgressStep: React.FC<ProgressStepProps> = ({
  first,
  last,
  passed,
  active,
  step,
  children,
}) => {
  const Checkmark: React.ComponentType = () => (
    <Icon className={styles.checkmark} large={true} name={IconName.Check} />
  );
  const PartyPopper: React.ComponentType = () => (
    <div className={styles.partyPopper}>&#x1F389;</div>
  );

  let StepSymbol: React.ComponentType = () => <span>{step}</span>;
  if (last && active) {
    StepSymbol = PartyPopper;
  } else if (passed) {
    StepSymbol = Checkmark;
  }

  return (
    <>
      {!first && (
        <div
          className={classes(styles.leftBar, {
            [styles.activeBar]: active,
            [styles.passedBar]: passed,
            [styles.firstStep]: first,
          })}
        />
      )}
      <div className={styles.progressStep}>
        <div
          className={classes(styles.stepNumber, {
            [styles.activeStep]: active,
            [styles.passedStep]: passed,
          })}
        >
          <StepSymbol />
        </div>
        <div
          className={classes(styles.stepName, {
            [styles.stepNameActive]: active,
          })}
        >
          {children}
        </div>
      </div>
    </>
  );
};

export const MoonshotProgressIndicator: React.FC<
  MoonshotProgressIndicatorProps
> = ({ activeStep = 3 }) => {
  return (
    <div className={styles.progressBar}>
      <ProgressStep first active={false} passed step={1}>
        Sign Up
      </ProgressStep>
      <ProgressStep active={activeStep === 1} passed={activeStep > 1} step={2}>
        Create Team
      </ProgressStep>
      <ProgressStep active={activeStep === 2} passed={activeStep > 2} step={3}>
        Invite Members
      </ProgressStep>
      <ProgressStep active={activeStep === 3} passed={activeStep > 3} step={4}>
        Select Plan
      </ProgressStep>
      <ProgressStep
        last
        active={activeStep === 4}
        passed={activeStep > 4}
        step={5}
      >
        Finished!
      </ProgressStep>
    </div>
  );
};
